import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogoLockup } from "./Logo";
import { VINEOPS_URL, scrollToSection } from "../constants/site";

const LINKS = [
  ["Philosophy", "philosophy"],
  ["About", "/about"],
  ["Services", "services"],
  ["Regions", "regions"],
  ["VineOps", "vineops"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F9F6F0]/85 border-b border-[#E5DEC9]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto flex flex-col items-center justify-center gap-3 py-4 px-6 md:flex-row md:justify-between md:py-0 md:px-12 md:h-[72px]">
        <button
          data-testid="nav-wordmark"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="transition-opacity duration-300 hover:opacity-70"
        >
          <LogoLockup light={!scrolled} size="sm" className="transition-opacity duration-300" />
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map(([label, id]) =>
            id.startsWith("/") ? (
              <Link
                key={id}
                to={id}
                data-testid="nav-link-about"
                className={`text-[11px] tracking-[0.22em] uppercase font-medium transition-colors duration-300 hover:text-[#B89B67] ${
                  scrolled ? "text-[#364132]" : "text-[#F9F6F0]/85"
                }`}
              >
                {label}
              </Link>
            ) : (
              <button
                key={id}
                data-testid={`nav-link-${id}`}
                onClick={() => scrollToSection(id)}
                className={`text-[11px] tracking-[0.22em] uppercase font-medium transition-colors duration-300 hover:text-[#B89B67] ${
                  scrolled ? "text-[#364132]" : "text-[#F9F6F0]/85"
                }`}
              >
                {label}
              </button>
            )
          )}
        </nav>

        <a
          data-testid="nav-client-login"
          href={VINEOPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={`shrink-0 inline-flex items-center gap-2 sm:gap-2.5 px-3.5 py-2.5 sm:px-5 sm:py-3 border transition-all duration-300 hover:bg-[#B89B67] hover:border-[#B89B67] active:scale-95 group ${
            scrolled
              ? "border-[#1A3626]"
              : "border-[#F9F6F0]/70"
          }`}
        >
          <img
            src={scrolled ? "/assets/vineops-mark.png" : "/assets/vineops-mark-light.png"}
            alt="VineOps"
            className="h-[11px] w-auto transition duration-300 group-hover:brightness-0"
          />
          <span className={`text-[10px] sm:text-[11px] tracking-[0.2em] uppercase font-semibold transition-colors duration-300 group-hover:text-[#12271B] ${
            scrolled ? "text-[#1A3626]" : "text-[#F9F6F0]"
          }`}>
            <span className="sm:hidden">Login</span>
            <span className="hidden sm:inline">Client Login</span>
          </span>
        </a>
      </div>
    </header>
  );
};
